import styled from "styled-components";

export const TicketAvailabilityInfoWrapper = styled.div`
  margin-top: 1rem;
`;
